export const sourceImagePreset = function(obj, scale) {
    obj.set({
        zIndex: 1,
        hoverCursor: 'default'
    })
    obj.scale(scale);
    obj.sendToBack();
    return obj;
};
